import { render } from "./PedidosReceber.vue?vue&type=template&id=ce454b22&scoped=true"
import script from "./PedidosReceber.vue?vue&type=script&lang=js"
export * from "./PedidosReceber.vue?vue&type=script&lang=js"

import "./PedidosReceber.vue?vue&type=style&index=0&id=ce454b22&scoped=true&lang=css"
import "./PedidosReceber.vue?vue&type=style&index=1&id=ce454b22&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce454b22"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QTable,QImg,QTd,QCheckbox,QBtn,QInput,QPopupProxy,QDate,QTooltip,QField});qInstall(script, 'directives', {ClosePopup});
